import { render, staticRenderFns } from "./vmiTransfer.vue?vue&type=template&id=626d9f80&scoped=true&"
import script from "./vmiTransfer.js?vue&type=script&lang=js&"
export * from "./vmiTransfer.js?vue&type=script&lang=js&"
import style0 from "./vmiTransfer.scss?vue&type=style&index=0&id=626d9f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626d9f80",
  null
  
)

export default component.exports